import React, { Component, useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as Sentry from "@sentry/browser";
import { withAlert } from "react-alert";
import PropTypes from "prop-types";

import Navigation from "./Navigation.js";
import {
  masqueradeAs,
  stopMasquerading,
  makeRequest,
  masqueradingMinutesLeft,
  masqueradeToken,
} from "./util";
import "./MasqueradePage.css";

const AutocompleteMasquerade = ({ value, onChange, ...rest }) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [visibleOptions, setVisibleOptions] = React.useState([]);

  useEffect(() => {
    if (open) {
      setVisibleOptions(options);
    } else {
      setVisibleOptions([]);
    }
  }, [open, options]);

  useEffect(() => {
    makeRequest("autocomplete_masquerade", { masquerade_value: value })
      .then((response) => {
        setOptions(response.data);
      })
      .catch((error) => {
        console.log(error);
        Sentry.captureException(error);
      });
  }, [value]);

  return (
    <Autocomplete
      id="Value"
      value={value}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      options={visibleOptions}
      // When first navigating to an event, onInputChange seems to be
      // fired even though it shouldn't be. This is causing issues with
      // the event being marked as edited when it shouldn't be.
      onInputChange={(event, value) => event && onChange(value)}
      freeSolo={true}
      disableClearable={true}
      loading={false}
      renderInput={(params) => (
        <div ref={params.InputProps.ref}>
          <input value={value} {...params.inputProps} {...rest} />
        </div>
      )}
    />
  );
};

AutocompleteMasquerade.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

// This is the page where an admin can masquarade as another user.
class MasqueradePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: "",
    };
  }

  handleTokenChange(value) {
    this.setState({ token: value });
  }

  handleStartMasquerading(token) {
    masqueradeAs(token);
    this.props.alert.success("You are now masquerading");
    setTimeout(() => window.location.reload(), 1000);
  }

  handleStopMasquerading() {
    stopMasquerading();
    this.props.alert.success("You are no longer masquerading");
    setTimeout(() => window.location.reload(), 1000);
  }

  render() {
    return (
      <Navigation>
        <div id="masquerade-page">
          <p>
            {masqueradeToken() &&
              "You are currently masquerading as " + masqueradeToken() + "."}
            Your masquerading session expires after one hour.{" "}
            {masqueradingMinutesLeft() &&
              `You have ${masqueradingMinutesLeft()} minutes left in the current session.`}
          </p>
          <AutocompleteMasquerade
            id="masquerade-input-field"
            className="fp-input-field"
            placeholder="Account ID or Email"
            value={this.state.token}
            onChange={(value) => this.handleTokenChange(value)}
          />

          <div id="start-masquerade-button-container">
            <div
              id="start-masquerade-button"
              className="fp-button fp-button-green"
              onClick={() => this.handleStartMasquerading(this.state.token)}
            >
              Start Masquerading
            </div>
          </div>

          <div id="stop-masquerade-button-container">
            <div
              id="stop-masquerade-button"
              className="fp-button fp-button-red"
              onClick={() => this.handleStopMasquerading()}
            >
              Stop Masquerading
            </div>
          </div>
        </div>
      </Navigation>
    );
  }
}

MasqueradePage.propTypes = {
  alert: PropTypes.func,
};

export default withAlert()(MasqueradePage);
